import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './freeinvite.css';

const API_URL = import.meta.env.VITE_API_URL;
const 曜日 = ['日', '月', '火', '水', '木', '金', '土'];

// 日付を「2025/01/15(水)」形式に
function formatDate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}/${m}/${d}(${曜日[date.getDay()]})`;
}

function formatmdDate(date) {
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${m}/${d}(${曜日[date.getDay()]})`;
}

// 時刻を「14：30」形式に
function formatTime(date) {
  const h = String(date.getHours()).padStart(2, '0');
  const m = String(date.getMinutes()).padStart(2, '0');
  return `${h}：${m}`;
}

// イベントから開始・終了日時を取得
function parseEventDates(event) {
  if (!event) return { start: null, end: null };

  const parseDateTime = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return null;
    const time = timeStr.length === 5 ? `${timeStr}:00` : timeStr;
    const d = new Date(`${dateStr}T${time}`);
    return isNaN(d) ? null : d;
  };

  const parseISO = (iso) => {
    if (!iso) return null;
    const d = new Date(iso);
    return isNaN(d) ? null : d;
  };

  const start = parseDateTime(event.start_date, event.start_time) || parseISO(event.start_time);
  const end = parseDateTime(event.end_date, event.end_time) || parseISO(event.end_time);

  return { start, end };
}

// 期間を表示用文字列に
function formatPeriod(event) {
  const { times_unified, schedules } = event || {};
  if (!schedules || schedules.length === 0) return '—';

  const fmt = (t) => String(t || '').slice(0, 5).replace(':', '：');

  const receptPart = (s) => {
    if (!s.recept_start_time || !s.recept_end_time) return '';
    return `（当日受付　${fmt(s.recept_start_time)}～${fmt(s.recept_end_time)}）`;
  };

  if (times_unified) {
    const first = schedules[0];
    const last  = schedules[schedules.length - 1];
    const datePart = schedules.length === 1
      ? formatDate(new Date(first.date))
      : `${formatDate(new Date(first.date))}～${formatDate(new Date(last.date))}`;
    return (
      <div>
        {`${datePart}　${fmt(first.start_time)}～${fmt(first.end_time)}${receptPart(first)}`}
      </div>
    );
  }

  return schedules.map((s, i) => (
    <div key={i}>
      {`${formatDate(new Date(s.date))}　${fmt(s.start_time)}～${fmt(s.end_time)}${receptPart(s)}`}
    </div>
  ));
}

// 受付時間（"HH:MM:SS" → "HH:MM～HH:MM"）
function formatReceptionTime(event) {
  if (!event?.recept_start || !event?.recept_end) return '';

  const toHHMM = (timeStr) => {
    if (typeof timeStr !== 'string') return '';
    // "11:00:00" などを想定
    if (timeStr.length >= 5) {
      // "HH" + ":" + "MM"
      return timeStr.slice(0, 2) + '：' + timeStr.slice(3, 5);
    }
    return timeStr;
  };

  const start = toHHMM(event.recept_start);
  const end = toHHMM(event.recept_end);
  if (!start || !end) return '';

  return `${start}～${end}`;
}


// イベント期間内の60,30分間隔スロットを生成
// mode: '30min' | '60min'
function generateDatetimeSlots(event, mode) {
  const schedules = event?.schedules || [];
  if (schedules.length === 0) return [];

  const intervalMin = mode === '60min' ? 60 : 30;

  const parseHHMM = (timeStr) => {
    if (!timeStr) return null;
    const parts = String(timeStr).split(':');
    return { h: parseInt(parts[0], 10), m: parseInt(parts[1], 10) };
  };

  const slots = [];

  for (const sc of schedules) {
    const day = new Date(sc.date);
    const receptStart = parseHHMM(sc.recept_start_time);
    const receptEnd   = parseHHMM(sc.recept_end_time);
    const evStart     = parseHHMM(sc.start_time);
    const evEnd       = parseHHMM(sc.end_time);

    const fromH = receptStart ? receptStart.h : (evStart ? evStart.h : 9);
    const fromM = receptStart ? receptStart.m : (evStart ? evStart.m : 0);
    const toH   = receptEnd   ? receptEnd.h   : (evEnd   ? evEnd.h   : 17);
    const toM   = receptEnd   ? receptEnd.m   : (evEnd   ? evEnd.m   : 0);

    const slotCur = new Date(day);
    slotCur.setHours(fromH, fromM, 0, 0);

    if (!receptStart) {
      const rem = slotCur.getMinutes() % intervalMin;
      if (rem !== 0) {
        slotCur.setMinutes(slotCur.getMinutes() - rem + intervalMin);
      }
    }

    const slotEnd = new Date(day);
    slotEnd.setHours(toH, toM, 0, 0);

    while (slotCur <= slotEnd) {
      slots.push(new Date(slotCur));
      slotCur.setMinutes(slotCur.getMinutes() + intervalMin);
    }
  }

  return slots;
}

// メインコンポーネント
export default function FreeInvite() {
  const [searchParams] = useSearchParams();
  const inviterToken = searchParams.get('inviter');

  // State
  const [event, setEvent] = useState(null);
  const [loadingEvent, setLoadingEvent] = useState(false);
  const [eventError, setEventError] = useState('');

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [groupSelections, setGroupSelections] = useState({});
  const [groupTexts, setGroupTexts] = useState({});

  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [done, setDone] = useState(null);

  // グループ入力の初期化
  const initGroupInputs = (ev) => {
    const selections = {};
    const texts = {};
    (ev.event_groups || []).forEach(g => {
      const types = g.types || [];
      const isDatetime = g.description?.startsWith('日時');
      const isFreeText = !isDatetime && types.length === 1 && types[0].event_type_name === '';
      if (isDatetime || isFreeText) {
        texts[g.event_group_id] = '';
      } else {
        selections[g.event_group_id] = '';
      }
    });
    setGroupSelections(selections);
    setGroupTexts(texts);
  };

  // イベント情報を取得
  const fetchEventPreview = async () => {
    setEventError('');
    setLoadingEvent(true);

    try {
      if (!inviterToken) {
        setEventError('招待URLが不正です。（inviter が不足）');
        return;
      }

      const res = await axios.get(`${API_URL}/api/free-invite/preview/`, {
        params: { inviterToken },
      });

      if (res.data?.success) {
        const ev = res.data.event;
        setEvent(ev);
        initGroupInputs(ev);
      } else {
        setEventError(res.data?.message || 'イベント情報の取得に失敗しました');
      }
    } catch (e) {
      console.error(e);
      if (e.response?.status === 404) {
        setEventError('無効なURLです。イベントが存在しません。');
      } else if (e.response?.status === 400) {
        setEventError('招待URLが不正です。');
      } else {
        setEventError('イベント情報の取得に失敗しました');
      }
    } finally {
      setLoadingEvent(false);
    }
  };

  // フォーム送信
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    setSubmitting(true);
    setSubmitError('');
    setDone(null);

    try {
      const answers = [
        ...Object.entries(groupSelections).map(([gid, typeId]) => ({
          event_group_id: Number(gid),
          event_type_id: typeId ? Number(typeId) : null,
          free_text: null,
        })),
        ...Object.entries(groupTexts).map(([gid, text]) => ({
          event_group_id: Number(gid),
          event_type_id: null,
          free_text: text.trim() || null,
        })),
      ];

      const res = await axios.post(`${API_URL}/api/free-invite/register/`, {
        inviter_token: inviterToken.trim(),
        guest_name: name.trim(),
        guest_email: email.trim(),
        guest_phone: phone.trim() || null,
        group_answers: answers,
      });

      if (res.data?.success) {
        setDone({
          message: 'ご登録いただきありがとうございます。',
          qr_code: '登録いただいたメールアドレスに招待状を送信しました。',
        });
        // フォームリセット
        setName('');
        setEmail('');
        setPhone('');
        initGroupInputs(event);
      } else {
        setSubmitError(res.data?.message || '登録に失敗しました');
      }
    } catch (e) {
      console.error(e);
      setSubmitError('登録に失敗しました');
    } finally {
      setSubmitting(false);
    }
  };

  // useMemo
  const canSubmit = useMemo(() => {
    if (!name.trim() || !email.trim() || submitting || !inviterToken || !event || eventError) {
      return false;
    }

    // 必須グループのチェック
    return (event.event_groups || []).every(g => {
      if (g.required_category !== 1) return true;
      const types = g.types || [];
      const isDatetime = g.description?.startsWith('日時');
      const isFreeText = !isDatetime && types.length === 1 && types[0].event_type_name === '';
      if (isDatetime || isFreeText) {
        return (groupTexts[g.event_group_id] ?? '').trim().length > 0;
      }
      return !!(groupSelections[g.event_group_id] ?? '');
    });
  }, [name, email, submitting, inviterToken, event, eventError, groupSelections, groupTexts]);

  // useEffect
  useEffect(() => {
    fetchEventPreview();
  }, [inviterToken]);

  // レンダリング関数
  const renderEventCard = () => (
    <div className="eventCard">
      <div className="cardHead">
        <div className="cardTitle">イベント情報</div>
        {loadingEvent && <span className="muted">読み込み中…</span>}
      </div>

      {eventError && <div className="error-alert">{eventError}</div>}

      {event && (
        <div className="eventBody">
          <div className="row">
            <div className="label">タイトル</div>
            <div className="value">{event.event_title}</div>
          </div>
          <div className="row">
            <div className="label">開催期間</div>
            <div className="value">{formatPeriod(event)}</div>
          </div>

         
          <div className="row">
            <div className="label">会場</div>
            <div className="value">{event.event_location || '-'}</div>
          </div>
          {event.capacity !== 0 && (
            <div className="row">
              <div className="label">定員</div>
              <div className="value">{event.capacity ?? '-'}{event.capacity > 0 ? ' 名' : ''}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );

  const renderGroupField = (g) => {
    const gid = g.event_group_id;
    const types = g.types || [];
    const isFreeText = types.length === 1 && types[0].event_type_name === '';
    const required = g.required_category === 1;
    const label = g.description ? `${g.group_name}（${g.description}）` : g.group_name;

    // ★ 必ず最初にチェック（isFreeText より前）
    const isDatetime = g.description?.startsWith('日時');
    if (isDatetime) {
      const mode = g.description?.includes(':') ? g.description.split(':')[1] : 'ampm';
      let options = [];
      if (mode === 'ampm') {
        const schedules = event?.schedules || [];

        options = schedules.flatMap(s => {
          const date = new Date(s.date);
          const dateStr = formatmdDate(date); // 04/22(水) みたいな

          return [
            `${dateStr} 午前`,
            `${dateStr} 午後`
          ];
        });
      } else {
        options = generateDatetimeSlots(event, mode).map(slot => `${formatmdDate(slot)} ${formatTime(slot)}`);
      }
      return (
        <label className="field" key={gid}>
          <span className="fieldLabel">{g.group_name}{required ? ' *' : ''}</span>
          <select
            className="datetimeSelect"
            value={groupTexts[gid] ?? ''}
            onChange={(e) => setGroupTexts(s => ({ ...s, [gid]: e.target.value }))}
          >
            <option value="">選択してください</option>
            {options.map((val, i) => (
              <option key={i} value={val}>{val}</option>
            ))}
          </select>
        </label>
      );
    }


    if (isFreeText) {
      const maxLen =
        (g.display_id === 2 || g.display_id === 3) ? 13 :
        (g.display_id === 4 || g.display_id === 5) ? 23 :
        undefined;
      return (
        <label className="field" key={gid}>
          <span className="fieldLabel">
            {label}{required ? ' *' : ''}
            {maxLen && (
              <span style={{ fontSize: '0.75rem', color: '#6b7280', paddingLeft: 10, fontWeight: 'normal' }}>
                {(groupTexts[gid] ?? '').length} / {maxLen}
              </span>
            )}
          </span>
          <input
            type="text"
            value={groupTexts[gid] ?? ''}
            onChange={(e) => setGroupTexts(s => ({ ...s, [gid]: e.target.value }))}
            placeholder={maxLen ? `入力してください（${maxLen}文字以内）` : '入力してください'}
            maxLength={maxLen}
          />
        </label>
      );
    }
    
    return (
      <label className="field" key={gid}>
        <span className="fieldLabel">{label}{required ? ' *' : ''}</span>
        <select
          value={groupSelections[gid] ?? ''}
          onChange={(e) => setGroupSelections(s => ({ ...s, [gid]: e.target.value }))}
        >
          <option value="">選択してください</option>
          {types.map(t => (
            <option key={t.event_type_id} value={t.event_type_id}>
              {t.event_type_name ?? '（名称未設定）'}
              {t.event_type_price > 0 ? `（${t.event_type_price.toLocaleString()}円）` : ''}
            </option>
          ))}
        </select>
      </label>
    );
  };

  const renderFormCard = () => {
    if (!event || eventError) return null;

    return (
      <div className="formCard">
        <div className="cardHead">
          <div className="cardTitle">参加者情報の入力</div>
        </div>

        {done && (
          <div className="success-alert">
            {done.message}
            {done.qr_code && <div className="qrHint">{done.qr_code}</div>}
          </div>
        )}

        {submitError && <div className="error-alert">{submitError}</div>}

        <form onSubmit={handleSubmit} noValidate>
          <div className="formGrid">
            <label className="field">
              <span className="fieldLabel">お名前 *</span>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="山田 太郎"
              />
            </label>

            <label className="field">
              <span className="fieldLabel">メールアドレス *</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="taro@example.com"
              />
            </label>

            <label className="field">
              <span className="fieldLabel">電話番号（任意）</span>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="090-1234-5678"
              />
            </label>

            {event?.event_groups?.map(renderGroupField)}
          </div>

          <div className="formOps">
            <span
              title={!canSubmit ? '「*」の必須項目を確認してください' : ''}
              className="btnTooltipWrap"
            >
              <button
                type="submit"
                className="btn primary"
                disabled={!canSubmit}
              >
                {submitting ? '送信中…' : '参加登録する'}
              </button>
            </span>
          </div>
        </form>
      </div>
    );
  };

  return (
    <div className="freeInvitePage">
      <h2 className="pageTitle">イベント招待</h2>

      {/* イベント情報カード */}
      {renderEventCard()}

      {/* 入力フォームカード */}
      {renderFormCard()}
    </div>
  );
}